<script>
    let className = ''; 
    export {className as class}; 
</script>


<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 {className}" style="background: #D1D3D4; color:#333333">
  <slot></slot>
</span>